import { render, staticRenderFns } from "./DeliveryTaskDetailModal.vue?vue&type=template&id=3bbcacc5&scoped=true"
import script from "./DeliveryTaskDetailModal.vue?vue&type=script&lang=js"
export * from "./DeliveryTaskDetailModal.vue?vue&type=script&lang=js"
import style0 from "./DeliveryTaskDetailModal.vue?vue&type=style&index=0&id=3bbcacc5&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbcacc5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bbcacc5')) {
      api.createRecord('3bbcacc5', component.options)
    } else {
      api.reload('3bbcacc5', component.options)
    }
    module.hot.accept("./DeliveryTaskDetailModal.vue?vue&type=template&id=3bbcacc5&scoped=true", function () {
      api.rerender('3bbcacc5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/order-receive/delivery/DeliveryTaskDetailModal.vue"
export default component.exports